'use client'

import { cn } from '@/utils/styles/cn'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

interface PopoverContentProps extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
    variant?: 'default' | 'dark'
}

const PopoverContent = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, PopoverContentProps>(
    ({ className, align = 'center', sideOffset = 4, variant = 'default', ...props }, ref) => (
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Content
                ref={ref}
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    `data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-[12px] border p-4 outline-hidden focus-visible:outline-none`,
                    variant === 'default' &&
                        'border-black/10 bg-popover text-popover-foreground shadow-custom dark:shadow-custom-black',
                    variant === 'dark' &&
                        'rounded-[6px] border border-[#FFFFFF14] bg-[#27272A] shadow-[0px_1px_0px_0px_rgba(255,255,255,0.20)_inset,0px_1px_2px_0px_rgba(0,0,0,0.40),0px_0px_0px_1px_#18181B]',
                    className
                )}
                {...props}
            />
        </PopoverPrimitive.Portal>
    )
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
